import './styles.scss';

export * from './CaptchaProtectedRoute';
